import React from 'react';
import { noop } from 'underscore';

import EditorTranscriptionOptions from 'components/EditorTranscriptionOptions';
import { block } from './utils';

interface EditorModalsTranscriptionOptionsProps {
  className?: string;
  clipDurationMillis?: number;
  hideReplacementWarning?: boolean;
  language?: string;
  onChangeLanguage?: (language: string) => void;
  onToggleTranscription?: (enabled: boolean) => void;
  onUpgradeClick?: () => void;
  skipUntoggleOnLimitPassed?: boolean;
  transcriptionEnabled: boolean;
}

const EditorModalsTranscriptionOptions: React.FunctionComponent<EditorModalsTranscriptionOptionsProps> = props => {
  const {
    className,
    clipDurationMillis,
    hideReplacementWarning,
    language,
    onChangeLanguage = noop,
    onToggleTranscription = noop,
    onUpgradeClick,
    skipUntoggleOnLimitPassed,
    transcriptionEnabled,
  } = props;

  return (
    <EditorTranscriptionOptions
      className={className}
      clipDurationMillis={clipDurationMillis}
      language={language}
      onLanguageSelected={onChangeLanguage}
      onToggleTranscription={onToggleTranscription}
      skipUntoggleOnLimitPassed={skipUntoggleOnLimitPassed}
      transcriptionEnabled={transcriptionEnabled}
    >
      <div>
        <EditorTranscriptionOptions.Toggle
          className={block('transcription-section')}
          labelClassName={block('transcription-section-title')}
          label="Captions"
        />
      </div>
      {!hideReplacementWarning && <EditorTranscriptionOptions.Warning />}
      <div>
        <EditorTranscriptionOptions.Language
          className={block('language-selector')}
        />
      </div>
      <EditorTranscriptionOptions.Balance
        durationInMilliseconds={clipDurationMillis}
        onClick={onUpgradeClick}
      />
    </EditorTranscriptionOptions>
  );
};

export default EditorModalsTranscriptionOptions;
